window.TD_ZONAS_ENTREGA = [
  { nome: 'ABCD', prefixos: ['090','091','092','095','096','097','098','099'], minimo: 10000, frete: 0 },
  { nome: 'Cidade de São Paulo', prefixos: ['01','02','03','04','05','080','081','082','083','084'], minimo: 100000, frete: 10000 },
  { nome: 'Mauá/Ribeirão Pires/Rio Grande da Serra', prefixos: ['093','094'], minimo: 50000, frete: 12000 },
  { nome: 'Oeste', prefixos: ['060','061','062','063','064','065','066','067','068','069'], minimo: 200000, frete: 20000 },
  { nome: 'Norte', prefixos: ['076','077','078','079'], minimo: 200000, frete: 30000 },
  { nome: 'Leste', prefixos: ['070','071','072','073','074','075','085','086','087','088','089'], minimo: 200000, frete: 40000 },
  { nome: 'Litoral', prefixos: ['110','111','112','113','114','115','117'], minimo: 200000, frete: 45000 },
  { nome: 'Interior/Campinas', prefixos: ['130','131','132'], minimo: 250000, frete: 40000 }
];

window.tdZonaDoCep = function (cepLimpo) {
  var zonas = window.TD_ZONAS_ENTREGA;
  for (var i = 0; i < zonas.length; i++) {
    var zona = zonas[i];
    for (var j = 0; j < zona.prefixos.length; j++) {
      if (cepLimpo.indexOf(zona.prefixos[j]) === 0) return zona;
    }
  }
  return null;
};

window.tdFormatBRL = function (centavos) {
  return (centavos / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
};
window.tdCheckCepAndRender = function (cepLimpo, resultBox, productTitle) {
  if (cepLimpo.length !== 8) {
    resultBox.hidden = false;
    resultBox.innerHTML = 'Digite um CEP válido (8 dígitos).';
    return;
  }

  var zona = window.tdZonaDoCep(cepLimpo);
  var waNumber = '551143688233';

  if (!zona) {
    var msgForaArea = 'Olá! Meu CEP é ' + cepLimpo + ' e gostaria de saber se vocês entregam na minha região' + (productTitle ? ' para o produto: ' + productTitle : '.');
    resultBox.hidden = false;
    resultBox.innerHTML =
      'Poxa, ainda não entregamos nessa região. ' +
      '<a href="https://wa.me/' + waNumber + '?text=' + encodeURIComponent(msgForaArea) + '" target="_blank" rel="noopener" class="link underlined-link">Fale com a gente no WhatsApp</a> que nosso time te ajuda a encontrar a melhor forma de receber seu pedido.';
    return;
  }

  fetch('/cart.js')
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      var falta = zona.minimo - cart.total_price;
      resultBox.hidden = false;
      if (falta > 0) {
        resultBox.innerHTML =
          'Entregamos na sua região (' + zona.nome + '). Faltam <strong>' + window.tdFormatBRL(falta) + '</strong> no carrinho para atingir o pedido mínimo de ' + window.tdFormatBRL(zona.minimo) + '.';
      } else {
        resultBox.innerHTML = 'Entregamos na sua região (' + zona.nome + '). Pedido mínimo já atingido.';
      }
    });
};